import { render, staticRenderFns } from "./HotsiteSlotsTable.vue?vue&type=template&id=5bf6e954"
import script from "./HotsiteSlotsTable.vue?vue&type=script&lang=js"
export * from "./HotsiteSlotsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports